import { render, staticRenderFns } from "./PatientInfoChannel.vue?vue&type=template&id=4e131165&"
import script from "./PatientInfoChannel.vue?vue&type=script&lang=ts&"
export * from "./PatientInfoChannel.vue?vue&type=script&lang=ts&"
import style0 from "./PatientInfoChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports